import { render } from "./gpuMining.vue?vue&type=template&id=2913cbb6&scoped=true"
import script from "./gpuMining.vue?vue&type=script&lang=js"
export * from "./gpuMining.vue?vue&type=script&lang=js"

import "./gpuMining.vue?vue&type=style&index=0&id=2913cbb6&lang=scss&scoped=true"

import exportComponent from "/home/ubuntu/dbc-website-build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2913cbb6"]])

export default __exports__